function isDateToday(puzzleDate) {
    // console.log('Original puzzleDate:', puzzleDate);
    if (!puzzleDate) {
        // console.log('No date provided.');
        return false;
    }

    // Convert YYYY-MM-DD to local date properly
    const [year, month, day] = puzzleDate.split('-').map(Number);
    const inputDate = new Date(year, month - 1, day); // Month is 0-based in JS Date

    const userDate = new Date();

    // Normalize both dates to remove the time portion
    inputDate.setHours(0, 0, 0, 0);
    userDate.setHours(0, 0, 0, 0);

    if (inputDate.getTime() === userDate.getTime()) {
        // console.log("The date is today.", true);
        return true;
    } else {
        // console.log("The date is not today.", false);
        return false;
    }
}

export default isDateToday;